// @flow
import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'

const Container = styled.footer`
  position: fixed;
  bottom: 1rem;
  left: 3rem;
`

type Props = {
  children: Node,
}

const Footer = ({ children }: Props) => <Container>{children}</Container>

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js